import { useEffect } from "react"

import { trackEvent } from "./Analytics"

const CTA_PRIMARY_HREF = "#contato"
const SCROLL_END_THRESHOLD = 0.92

export function AnalyticsTracker() {
  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null
      if (!target) {return}
      const link = target.closest("a")
      if (!link) {return}
      const href = link.getAttribute("href") ?? ""
      if (href === CTA_PRIMARY_HREF) {
        trackEvent("cta_primary_click", {
          label: link.textContent?.trim().slice(0, 50),
          location: link.closest("section")?.id ?? "unknown",
        })
      }
    }

    let scrollEndFired = false
    const scrollHandler = () => {
      if (scrollEndFired) {return}
      const scrolled = window.scrollY + window.innerHeight
      const total = document.documentElement.scrollHeight
      if (total > 0 && scrolled / total >= SCROLL_END_THRESHOLD) {
        scrollEndFired = true
        trackEvent("scroll_end")
      }
    }

    document.addEventListener("click", clickHandler)
    window.addEventListener("scroll", scrollHandler, { passive: true })

    return () => {
      document.removeEventListener("click", clickHandler)
      window.removeEventListener("scroll", scrollHandler)
    }
  }, [])

  return null
}
